<div class="modal">
  <div class="modal-ctn">

    <div class="options">
      <div class="controls">
        <input type="text" [(ngModel)]="textFilter" (keyup)="filterTeams()">
        <select (change)="filterTeamsLocation($event)">
          @for (location of locations; track location) {
            <option
              [value]="location.code"
              [selected]="location.code === locationCodeFilter">
              {{ location.name }}
            </option>
          }
        </select>
        @if (translations) {
          <select (change)="selectMarket($event)">
            @for (market of markets | keyvalue; track market) {
              <option
                [value]="market.value"
                [selected]="selectedMarket === market.value">
                {{ translations[market.key] }}
              </option>
            }
          </select>
        }
      </div>
      <img src="assets/images/close.svg" (click)="close()"/>
    </div>


    <div class="teams">
      @for (team of displayedTeams; track team) {
        <div class="team">
          <div class="logo">
            <img src="assets/images/team-member.svg"/>
            @if (team.teamMemberId?.toUpperCase().startsWith('EXT')) {
              <span class="badge-external">
                External
              </span>
            }
            @if (!team.teamMemberId?.toUpperCase().startsWith('EXT')) {
              <span>
                {{ team.teamMemberId }}
              </span>
            }
          </div>
          <div class="info">
            <a>{{ team.teamMemberFirstName }} {{ team.teamMemberName }}</a>
            <a>{{ team.teamMemberEmail }}</a>
          </div>
          <div class="add" (click)="add(team)">
            <img src="assets/images/add-shopping-cart.svg"/>
          </div>
        </div>
      }
    </div>

  </div>
</div>